import React from 'react';
import Layout from '@/common/Layout';
import AuditTrailsPage from './components/AuditTrailsPage';

const AuditTrails = () => {
  return (
    <>
      <Layout sider={false}>
        <AuditTrailsPage />
      </Layout>
    </>
  );
};

export default AuditTrails;
